"use strict";

exports.__esModule = true;
exports.AggregateMeasureTableFields = AggregateMeasureTableFields;
exports.boostrapDefaultAdvancedDataTableColumns = boostrapDefaultAdvancedDataTableColumns;
var _partition2 = _interopRequireDefault(require("ramda/src/partition"));
var _react = _interopRequireDefault(require("react"));
var _Core = require("../../Core");
var _AdvancedDataSources = require("../AdvancedDataTable/AdvancedDataSources");
var _Fields = require("../AdvancedDataTable/Fields");
var _AdvancedDataTableColumn = require("../AdvancedDataTableColumn");
var _AggregateTimeDefinitions = require("./AggregateTimeDefinitions");
var _MeasureTimelineColumnFieldSelector = require("./Fields/MeasureTimelineColumnFieldSelector");
var _excluded = ["columns"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function boostrapDefaultAdvancedDataTableColumns(configuration, elementEditor, definition, path) {
  if (configuration === void 0) {
    configuration = {};
  }
  // Use the definition to bootstrap a default configuration for the editor
  var _definition$createDef = definition.createDefault(),
    columns = _definition$createDef.columns,
    defaultConfig = _objectWithoutPropertiesLoose(_definition$createDef, _excluded);
  configuration = defaultConfig;

  // bootstrap the child elements
  elementEditor.modifyElementAt(path, function (el) {
    // Create a column for each in the defaults as a child of the element. Note: Destroys existing configured columns
    el.children = columns.map(function (column) {
      return _AdvancedDataTableColumn.AdvancedDataTableColumnWidget.createElement(Object.assign({}, column));
    });
  });
  return configuration;
}

/**
 * Divide all columns into measure and dimension columns
 */
var getGroupedColumns = function getGroupedColumns(allDefinition) {
  if (!allDefinition) {
    return {
      measureColumns: [],
      dimensionColumns: []
    };
  }
  var groupedColumns = allDefinition.columns.map(function (column) {
    return Object.assign({}, column, {
      groupId: column.id,
      groupLabel: column.name,
      label: column.name
    });
  });
  var allColumns = (0, _partition2["default"])(function (column) {
    return column.id.split(".")[0] === "measures" || column.id === "duration";
  }, groupedColumns);
  var measureColumns = [].concat(allColumns[0]);
  var dimensionColumns = [].concat((0, _AggregateTimeDefinitions.aggregateTimeDefinitions)().columns, allColumns[1]);
  return {
    measureColumns: measureColumns,
    dimensionColumns: dimensionColumns
  };
};

/**
 * Fields for AdvancedDataTableElement.
 */
function AggregateMeasureTableFields(props) {
  var path = props.path,
    elementEditor = props.elementEditor,
    element = props.element;
  var renderChildren = function renderChildren(data) {
    var timelineDefinitions = data.timelineDefinitions;
    var dataSource = element.props.dataSource;
    var allDefinition = dataSource && timelineDefinitions[dataSource] ? timelineDefinitions[dataSource] : null;
    var _getGroupedColumns = getGroupedColumns(allDefinition),
      measureColumns = _getGroupedColumns.measureColumns,
      dimensionColumns = _getGroupedColumns.dimensionColumns;
    var configuration = element.props.configuration;
    if (!configuration && allDefinition) {
      configuration = boostrapDefaultAdvancedDataTableColumns(configuration, elementEditor, allDefinition, path);
      elementEditor.setProp(path, "configuration", configuration);
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      "data-testid": "AggregateMeasureTableFields"
    }, /*#__PURE__*/_react["default"].createElement(_MeasureTimelineColumnFieldSelector.MeasureTimelineColumnFieldSelector, _extends({}, props, {
      data: data,
      measureColumns: measureColumns,
      dimensionColumns: dimensionColumns
    })), /*#__PURE__*/_react["default"].createElement(_Fields.AdvancedDataRangeSelector, {
      value: element.props.dataRange,
      setProp: function setProp(val) {
        elementEditor.modifyElementAt(path, function (el) {
          if (el.props.dataRange !== val) {
            el.props.dataRange = val;
          }
        });
      },
      fetchDataOnlyOnSelection: element.props.fetchDataOnlyOnSelection,
      setFetchOnlyOnSelection: function setFetchOnlyOnSelection(val) {
        elementEditor.modifyElementAt(path, function (el) {
          if (el.props.fetchDataOnlyOnSelection !== val) {
            el.props.fetchDataOnlyOnSelection = val;
          }
        });
      }
    }), /*#__PURE__*/_react["default"].createElement(_Fields.AdvancedPaginationField, {
      defaultPageSize: configuration ? configuration.defaultPageSize : "auto",
      setDefaultPageSize: function setDefaultPageSize(val) {
        return elementEditor.setProp(path, "configuration", Object.assign({}, element.props.configuration, {
          defaultPageSize: val
        }));
      },
      enablePagination: configuration ? configuration.enablePagination : true,
      setPagination: function setPagination(val) {
        return elementEditor.setProp(path, "configuration", Object.assign({}, element.props.configuration, {
          enablePagination: val
        }));
      }
    }));
  };
  return /*#__PURE__*/_react["default"].createElement(_AdvancedDataSources.AdvancedDataSourceContext.Consumer, null, function (_ref) {
    var loaded = _ref.loaded,
      fetching = _ref.fetching,
      error = _ref.error,
      data = _ref.data;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, fetching && !data ? /*#__PURE__*/_react["default"].createElement(_Core.Spinner, null) : null, !error && loaded && data ? renderChildren(data) : null);
  });
}